// extracted by mini-css-extract-plugin
module.exports = {"container":"NoAccessToApp_container__1UBj_","iconColor":"NoAccessToApp_iconColor__3l6-1","bold":"NoAccessToApp_bold__3kw0H","light":"NoAccessToApp_light__FGGYQ"};